import FailedOrderReason from '../../../../constants/FailedOrderReason'
import DashboardActionTypes from './DashboardActionTypes'

export interface SetFailedOrderId {
  type: DashboardActionTypes.SET_FAILED_ORDER_ID
  payload: {
    orderId: number
    reason: FailedOrderReason
  }
}

export function setFailedOrderId(orderId: number, reason: FailedOrderReason): SetFailedOrderId {
  return {
    type: DashboardActionTypes.SET_FAILED_ORDER_ID,
    payload: {
      orderId,
      reason,
    },
  }
}

export interface ResetFailedOrderId {
  type: DashboardActionTypes.RESET_FAILED_ORDER_ID
}

export function resetFailedOrderId(): ResetFailedOrderId {
  return {
    type: DashboardActionTypes.RESET_FAILED_ORDER_ID,
  }
}
